import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginPage } from '../features/auth/components/LoginPage';
import { leaveSignInWhenSignedIn } from '../features/auth/route-guard';

const SignInSearchSchema = z.object({
  /** The page to return to; checked again before it is used (return-path.ts). */
  redirect: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
  staticData: { public: true },
  validateSearch: SignInSearchSchema,
  beforeLoad: ({ context, search }) => {
    leaveSignInWhenSignedIn(context.authenticator, search.redirect);
  },
  component: LoginPage,
});
